import React, {useEffect} from 'react';
import * as classes from './index.module.css'
import { useStore, setNavState } from '@UseCase/store';
import { useSplitText } from '@UseCase/useSplitText';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';

const Navigation = ({location}) => {

    const [store, dispatch] = useStore();
    const { scrollPosition, navOpenState, isInLightSection, currentPage, headerBG} = store;

    const setNav = () => {
        setNavState(dispatch, navOpenState !== 'nav' ? 'nav' : '');
    }

    useEffect(() => {
        setNavState(dispatch, '');
    }, [location, dispatch]);

    return (
        <nav className={`${classes.root} ${(headerBG && scrollPosition < 100)  && classes.withBG } ${isInLightSection ? !headerBG ? classes.lightRoot : scrollPosition > 100 &&  classes.lightRoot: classes.darktRoot}`}>
            <ul className={`${classes.nav} ${scrollPosition > 100 ? classes.navHide : classes.navShow}`}>
                <li className={classes.linkItem}>
                    <Link to="/about" aria-label="About" className={classes.link} data-active={currentPage === 'about' ? true : false}>
                        <span className={classes.mainText} aria-hidden="true">{useSplitText('About')}</span>
                        <span className={classes.secondaryText}>About</span>
                    </Link>
                </li>
                <li className={classes.linkItem}>
                    <Link to="/services" aria-label="Services" className={classes.link} data-active={currentPage === 'services' ? true : false}>
                        <span className={classes.mainText} aria-hidden="true">{useSplitText('Services')}</span>
                        <span className={classes.secondaryText}>Services</span>
                    </Link>
                </li>
                <li className={classes.linkItem}>
                    <Link to="/work" aria-label="Work" className={classes.link} data-active={currentPage === 'work' ? true : false}>
                        <span className={classes.mainText} aria-hidden="true">{useSplitText('Work')}</span>
                        <span className={classes.secondaryText}>Work</span>
                    </Link>
                </li>
                <li className={classes.linkItem}>
                    <Link to="/culture" aria-label="Culture" className={classes.link} data-active={currentPage === 'culture' ? true : false}>
                        <span className={classes.mainText} aria-hidden="true">{useSplitText('Culture')}</span>
                        <span className={classes.secondaryText}>Culture</span>
                    </Link>
                </li>
                <li className={classes.linkItem}>
                    <Link to="/newsroom" aria-label="Newsroom" className={classes.link} data-active={currentPage === 'newsroom' ? true : false}>
                        <span className={classes.mainText} aria-hidden="true">{useSplitText('Newsroom')}</span>
                        <span className={classes.secondaryText}>Newsroom</span>
                    </Link>
                </li>
                <li className={classes.linkItem}>
                    <Link to="/contact" aria-label="Contact" className={classes.link} data-active={currentPage === 'contact' ? true : false}>
                        <span className={classes.mainText} aria-hidden="true">{useSplitText('Contact')}</span>
                        <span className={classes.secondaryText}>Contact</span>
                    </Link>
                </li>
            </ul>
            <div className={`${classes.megaNavContainer} ${navOpenState === 'nav' ? classes.megaNavShow : classes.megaNavHide}`}>
                <ul className={classes.megaNav}>
                    <li className={classes.linkItem}>
                        <Link to="/about" aria-label="About" className={classes.link} data-active={currentPage === 'about' ? true : false}>
                            <span className={classes.mainText} aria-hidden="true">{useSplitText('About')}</span>
                            <span className={classes.secondaryText}>About</span>
                        </Link>
                    </li>
                    <li className={classes.linkItem}>
                        <Link to="/services" aria-label="Services" className={classes.link} data-active={currentPage === 'services' ? true : false}>
                            <span className={classes.mainText} aria-hidden="true">{useSplitText('Services')}</span>
                            <span className={classes.secondaryText}>Services</span>
                        </Link>
                    </li>
                    <li className={classes.linkItem}>
                        <Link to="/work" aria-label="Work" className={classes.link} data-active={currentPage === 'work' ? true : false}>
                            <span className={classes.mainText} aria-hidden="true">{useSplitText('Work')}</span>
                            <span className={classes.secondaryText}>Work</span>
                        </Link>
                    </li>
                    <li className={classes.linkItem}>
                        <Link to="/culture" aria-label="Culture" className={classes.link} data-active={currentPage === 'culture' ? true : false}>
                            <span className={classes.mainText} aria-hidden="true">{useSplitText('Culture')}</span>
                            <span className={classes.secondaryText}>Culture</span>
                        </Link>
                    </li>
                    <li className={classes.linkItem}>
                        <Link to="/newsroom" aria-label="Newsroom" className={classes.link} data-active={currentPage === 'newsroom' ? true : false}>
                            <span className={classes.mainText} aria-hidden="true">{useSplitText('Newsroom')}</span>
                            <span className={classes.secondaryText}>Newsroom</span>
                        </Link>
                    </li>
                    <li className={classes.linkItem}>
                        <Link to="/contact" aria-label="Contact" className={classes.link} data-active={currentPage === 'contact' ? true : false}>
                            <span className={classes.mainText} aria-hidden="true">{useSplitText('Contact')}</span>
                            <span className={classes.secondaryText}>Contact</span>
                        </Link>
                    </li>
                </ul>
            </div>
            <button aria-label="Navigation Button" className={`${classes.toggle} ${scrollPosition > 100 ? classes.toggleShow : ''} ${navOpenState === 'nav' ? classes.close : ''}`} onClick={setNav}></button>
        </nav>
    );
};

Navigation.propTypes = {
    location: PropTypes.object
};

export default Navigation;